module.exports = __webpack_public_path__ + "static/home5-b906cb871a905c5fa5c409fb8ce66483.jpg";